import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../shared/services/auth-context/auth-context";

interface ProtectedRouteProps {

}

function ProtectedRoute(props: ProtectedRouteProps) {

    const { canLogin } = useContext(AuthContext);
    const location = useLocation();

    if(location.pathname === "/login") {
        return (
            canLogin ?
            <Navigate to="/" />
            :
            <Outlet />
        );
    } else {
        return (
            canLogin ?
            <Outlet />
            :
            <Navigate to="/login" state={{ from: location.pathname }} replace={true} />
    
        );
    }

}

export default ProtectedRoute;